"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** A substitute for string.startsWith */
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
exports.default = startsWith;
